import axios from 'axios'

import { getToken } from '@/util/auth'
import { message } from 'ant-design-vue';
import router from '@/router/index'

const adminTarget = 'https://yh.jetsitongsoft.com/admin/'
const webTarget = 'https://yh.jetsitongsoft.com/'

const joinUrl = (base, path) => {
  if (/^https?:\/\//i.test(path)) {
    return path
  }

  return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
}

const appendParams = (url, params) => {
  if (!params) {
    return url
  }

  const search = new URLSearchParams()
  Object.keys(params).forEach(key => {
    const value = params[key]
    if (value === undefined || value === null) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach(item => search.append(key, item))
      return
    }

    search.append(key, value)
  })

  const query = search.toString()
  if (!query) {
    return url
  }

  return `${url}${url.includes('?') ? '&' : '?'}${query}`
}

const getProxyTargetUrl = config => {
  const requestUrl = config.url || ''

  if (/^https?:\/\//i.test(requestUrl)) {
    return appendParams(requestUrl, config.params)
  }

  if (requestUrl.startsWith('/api')) {
    return appendParams(joinUrl(adminTarget, requestUrl.replace(/^\/api\/?/, '')), config.params)
  }

  if (requestUrl.startsWith('/common')) {
    return appendParams(joinUrl(webTarget, requestUrl), config.params)
  }

  if (requestUrl.startsWith('/store')) {
    return appendParams(joinUrl(webTarget, requestUrl.replace(/^\/store\/?/, '')), config.params)
  }

  if (requestUrl.startsWith('/temp')) {
    return appendParams(joinUrl(webTarget, requestUrl), config.params)
  }

  return appendParams(joinUrl(config.baseURL || window.location.origin, requestUrl), config.params)
}

// `timeout` 指定请求超时的毫秒数。
// 如果请求时间超过 `timeout` 的值，则请求会被中断
axios.defaults.timeout = 3000000
axios.defaults.withCredentials = true;
// `validateStatus` 定义了对于给定的 HTTP状态码是 resolve 还是 reject promise。
// 如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，
// 则promise 将会 resolved，否则是 rejected。


// `withCredentials` 表示跨域请求时是否需要使用凭证
// axios.defaults.withCredentials = true;

//HTTPrequest拦截
axios.interceptors.request.use(
  config => {
    // 避免http缓存
    const requestUrl = config.url || ''
    const isLoginRequest = /\/Login\/login$/i.test(requestUrl)
    const token = getToken()
    if (!isLoginRequest && typeof token === 'string' && token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    console.log('[接口请求]', {
      method: (config.method || 'get').toUpperCase(),
      url: getProxyTargetUrl(config),
      proxyUrl: appendParams(config.url || '', config.params),
      data: config.data
    })

    return config;
  },
  error => {
    return Promise.reject(error)
  }
);

//HTTPresponse拦截
axios.interceptors.response.use(
  response => {
    const status = response.status || 200
    //如果是401则跳转到登录页面
    // if (status === 401) {
    //   store.dispatch('LogOut').then(() => router.push({ path: '/login' }));
    // }
    if (status !== 200) {
      const message = response.data.msg || response.data.message
      return Promise.reject(message)
    }
    const code = response.data.code
    if (code === 401) {
      router.push('/login')
      // message.error(response.data.msg)
    }
    if (response.data == undefined) {
      return response
    }
    return response.data;
  },
  error => {
    if (error.message == 'timeout of 30000ms exceeded') {
      message.error('请求超时')
    } else {
      message.error('服务器异常')
      return Promise.reject(error)
    }
  }
)
export default axios;
